import { ApiResponse } from '../../../../constants/types';
import {
  ClassBookItem,
  ClassLessonItem,
  ContentsDataType,
  ContentType,
  LastTeachingBookItem,
  SubjectCodeType,
} from '../../../../constants/types/lms/take-class/type';
import instance from '../../../axios/utils.ts/instance';

interface ClassBookListParams {
  classId: string;
}

/**
 * LMS > 수업하기 : 북 목록 조회
 * @param classId
 * @returns
 */
export const getClassBookList = async (params: ClassBookListParams) => {
  const { classId } = params;

  const result = await instance.get<ApiResponse<{ books: ClassBookItem[] }>>(
    `/v1/lms/${classId}/jebson/books`,
  );

  return result.data.data;
};

interface LastTeachingBookParams {
  classId: string;
}

/**
 * LMS > 수업하기 : 마지막 수업 위치 조회
 * @returns
 */
export const getLastTeachingBook = async (params: LastTeachingBookParams) => {
  const { classId } = params;

  const result = await instance.get<ApiResponse<LastTeachingBookItem>>(
    `/v1/lms/last-teaching?classId=${classId}`,
  );

  return result.data.data;
};

interface ClassLessonListParams {
  classId: string;
  bookCode: string;
}

/**
 * LMS > 수업하기 : 레슨 목록 조회
 * @param classId
 * @returns
 */
export const getClassLessonList = async (params: ClassLessonListParams) => {
  const { classId, bookCode } = params;

  const result = await instance.get<
    ApiResponse<{ bookCode: string; lessons: ClassLessonItem[] }>
  >(`/v1/lms/jebson/books/${bookCode}/lessons`, { params: { classId } });

  return result.data.data;
};

interface PostContentViewParams {
  bookCode: string;
  lesson: string;
  subjectCode: SubjectCodeType;
  contentType: ContentType;
}

/**
 * LMS > 수업하기 : 콘텐츠 열람 기록
 * @param bookCode
 * @param lesson
 * @param subjectCode
 * @param contentType
 * @returns
 */
export const postContentView = async (params: PostContentViewParams) => {
  const result = await instance.post(`/v1/lms/jebson/content-view`, params);

  return result.data.data;
};

/**
 * LMS > 수업하기 : 콘텐츠 링크 조회
 * @param classId
 * @param contentId
 * @returns
 */
export const getContentsDatas = async (
  classId: string,
  contentId: string,
): Promise<ContentsDataType> => {
  // 에러 code(리딩온 404 등)별 안내를 위해 호출부(useContentsMessage)로 에러를 그대로 던진다.
  const path = `/v1/class/${classId}/contents/${contentId}`;
  const rtn = await instance.get(path);
  return rtn.data.data;
};
